import Rete from "rete";
import { NumberSocket } from "../../rete-controls/NumberControl.js";
import AnyTypeSocket, { ArraySocket } from "../../../Utils/CommonSockets.js";
import { ToggleSocket } from "../../rete-controls/ToggleControl.js";
import { ResetSocket } from "../../rete-controls/ResetControl.js";
import { ProgressControl } from "../../rete-controls/ProgressControl";
import { EventBus } from "../../../event-bus.js";

export default class NumberArrayToStream extends Rete.Component {
  constructor() {
    super("Any Stream"); // name
    this._categories = ["Simulator"];
    this._nodeStateData = {};

    this._eventRegistered = false;

    EventBus.$on("global-reset-nodes", x => {
      this.doResetNode("all");
    });
  }
  buildNodeData(node) {
    if (node !== null && node !== undefined && node.id != undefined) {
      this._nodeStateData[node.id] = {
        counter: 0,
        currentConnectedInput: null,
        lastValue: null,
        lastIndex: null,
        resetConnected: false,
        percentage: 0,
        reset() {
          this.counter = 0;
          this.currentConnectedInput = null;
          this.lastValue = null;
          this.lastIndex = null;
          this.percentage = 0;
        }
      };
    }
  }
  registerOnRemove() {
    if (!this._eventRegistered) {
      var data = this._nodeStateData;
      this.editor.on("noderemoved", nodex => {
        console.log("removing " + nodex.id);

        if (data[nodex.id] !== null && data[nodex.id] !== undefined) {
          console.log("data gone " + nodex.id);

          delete data[nodex.id];
        }
      });
    }
    this._eventRegistered = true;
  }
  
  builder(node) {
    let inp1 = new Rete.Input("in1", "On/Off (Toggle)", ToggleSocket);
    let inp2 = new Rete.Input("in2", "Any Array", AnyTypeSocket);
    var inp3 = new Rete.Input("resetIn", "Reset", ResetSocket);

    let out1 = new Rete.Output("out1", "Any", AnyTypeSocket);
    let out2 = new Rete.Output("out2", "Index", NumberSocket);

    let contrl1 = new ProgressControl(this.editor, "progress");

    this.buildNodeData(node);
    this.registerOnRemove();
    return node
      .addInput(inp1)
      .addInput(inp2)
      .addInput(inp3)
      .addOutput(out1)
      .addOutput(out2)
      .addControl(contrl1);
  }
  doResetNode(node) {
    if (node == "all") {
      for (const key in this._nodeStateData) {
        if (this._nodeStateData.hasOwnProperty(key)) {
          const element = this._nodeStateData[key];
          element.reset();
        }
      }
    } else {
      this._nodeStateData[node.id].reset();
    }
  }
  resetNode(in3, node) {
    if (node.inputs["resetIn"].connections[0] != null)
      if (in3 !== null && in3 !== undefined) this.doResetNode(node);
  }
  updateProgress(node) {
    this.editor.nodes
      .find(n => n.id == node.id)
      .controls.get("progress")
      .setValue(this._nodeStateData[node.id].percentage);
  }
  worker(node, inputs, outputs) {
    this.resetNode(inputs["resetIn"][0], node);
    let in1 = inputs["in1"];
    let in2 = inputs["in2"][0];

    let arrayValue = [];

    if (in2 != [] && in2 !== undefined) {
      let newConnection = node.inputs["in2"].connections[0];
      if (this._nodeStateData[node.id].currentConnectedInput != null) {
        if (
          newConnection.node !==
            this._nodeStateData[node.id].currentConnectedInput.node ||
          newConnection.output !==
            this._nodeStateData[node.id].currentConnectedInput.output
        ) {
          this._nodeStateData[node.id].currentConnectedInput = newConnection;
          this._nodeStateData[node.id].counter = 0;
          this._nodeStateData[node.id].lastValue = null;
        }
      } else {
        this._nodeStateData[node.id].currentConnectedInput = newConnection;
        this._nodeStateData[node.id].counter = 0;
        this._nodeStateData[node.id].lastValue = null;
        this._nodeStateData[node.id].lastIndex = null;
      }
      arrayValue = in2;

      if (!(arrayValue instanceof Array))
        if (arrayValue instanceof Object)
          if (typeof arrayValue.asArray === "function") {
            arrayValue = arrayValue.asArray();
          }
    } else {
      this._nodeStateData[node.id].currentConnectedInput = null;
      outputs["out1"] = null;
      outputs["out2"] = null;

      return;
    }

    // if( in1.length === 0 || in1[0] === false){
    //   if (node.outputs["out1"].connections.length > 0 && this._lastValue != null){
    //     outputs["out1"] = this._lastValue;
    //     outputs["out2"] = this._lastIndex ;
    //   }
    //   return;
    // }

    if (node.outputs["out1"].connections.length > 0) {
      let updateCounter = false;
      if (this._nodeStateData[node.id].counter < arrayValue.length) {
        this._nodeStateData[node.id].lastValue =
          arrayValue[this._nodeStateData[node.id].counter];
        outputs["out1"] = this._nodeStateData[node.id].lastValue;
        updateCounter = true;
      }
      if (updateCounter && node.outputs["out2"].connections.length > 0) {
        this._nodeStateData[node.id].lastIndex = this._nodeStateData[
          node.id
        ].counter;
        outputs["out2"] = this._nodeStateData[node.id].lastIndex;
      }

      if (updateCounter)
        this._nodeStateData[node.id].counter =
          this._nodeStateData[node.id].counter + 1;
      var currentPercentage =
        Math.floor(
          ((this._nodeStateData[node.id].counter / arrayValue.length) * 100) / 5
        ) * 5;

      if (this._nodeStateData[node.id].percentage !== currentPercentage)
        this._nodeStateData[node.id].percentage = currentPercentage;
    }
    this.updateProgress(node);
  }
}
